
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  appraisalState,
  selectAppraisalById,
  updateAppraisal,
} from "./appraisalSlice";

import { getAllAppraisal } from "../../api/appraisalApi";
import { getAllUsers } from "../../api/userApi";
import { getAllTemplates } from "../../api/templateApi";
import { useNavigate, useSearchParams } from "react-router-dom";

import { ArrowBackIos } from "@mui/icons-material";
import Loader from "../../components/Loader";

const UpdateManagerAppraisal = () => {
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [submitReferenceState, setSubmitReferenceState] = useState();
  const dispatch = useDispatch();
  const naviagte = useNavigate();

  const stateOfAppraisal = useSelector(appraisalState);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const findTemplate = useSelector((state) => selectAppraisalById(state, id));

  useEffect(() => {
    setSelectedTemplate(findTemplate);
  }, [findTemplate]);

  useEffect(() => {
    dispatch(getAllAppraisal());
    dispatch(getAllUsers());
    dispatch(getAllTemplates());
  }, [dispatch]);

  useEffect(() => {
    setSubmitReferenceState(false);
  }, [submitReferenceState]);

  const trimObjectValues = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(trimObjectValues);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[key] = trimObjectValues(obj[key]);
        return acc;
      }, {});
    } else if (typeof obj === "string") {
      return obj.trim();
    }
    return obj;
  };
  const validateSelectedOptionIds = () => {
    const hasEmptyOptionId = selectedTemplate?.appraisalQuestionAnswer?.some(
      (obj) => obj?.selectedOptionId === "" || obj?.selectedOptionId === null
    );

    if (hasEmptyOptionId) {
      alert("Please select an option for all questions.");
      return false;
    }

    return true;
  };

  const handleEditAppraisal = () => {
    if (validateSelectedOptionIds()) {
      dispatch(updateAppraisal(trimObjectValues(selectedTemplate)));
    }
  };

  const handleRadioChange = (e, questionId, optionId) => {
    setSelectedTemplate((prevValues) => ({
      ...prevValues,
      appraisalQuestionAnswer: prevValues?.appraisalQuestionAnswer?.map((obj) =>
        obj?.appraisalQuestions?.id === questionId
          ? {
              ...obj,
              selectedOptionId: optionId,
              comment: obj.comment,
            }
          : obj
      ),
    }));
  };

  const handleCheckBoxChange = (e, questionId, optionId) => {
    //for single true entry
    if (e.target.checked) {
      setSelectedTemplate((prevValues) => ({
        ...prevValues,
        appraisalQuestionAnswer: prevValues?.appraisalQuestionAnswer?.map(
          (obj) =>
            obj?.appraisalQuestions?.id === questionId
              ? {
                  ...obj,
                  selectedOptionId: optionId,
                  comment: obj.comment,
                }
              : obj
        ),
      }));
    } else {
      setSelectedTemplate((prevValues) => ({
        ...prevValues,
        appraisalQuestionAnswer: prevValues?.appraisalQuestionAnswer?.map(
          (obj) =>
            obj?.appraisalQuestions?.id === questionId
              ? {
                  ...obj,
                  selectedOptionId: "",
                  comment: obj.comment,
                }
              : obj
        ),
      }));
    }
  };

  const handleInputComment = (e, type, questionId) => {
    setSelectedTemplate((prevValues) => ({
      ...prevValues,
      appraisalQuestionAnswer: prevValues?.appraisalQuestionAnswer?.map((obj) =>
        obj?.appraisalQuestions?.id === questionId
          ? {
              ...obj,
              comment: e?.target?.value,
            }
          : obj
      ),
    }));
  };

  return (
    <>
      {stateOfAppraisal?.loading && <Loader />}
      <div className="rounded-sm border border-stroke bg-white shadow-default">
        <div className="flex w-full justify-center items-center bg-primary">
          <button
            onClick={() => naviagte("/mgr/all-appraisals")}
            className="flex w-32 pl-3 text-white cursor-pointer bg-transparent border-none outline-none"
            aria-label="Go back to all appraisals"
          >
            <ArrowBackIos /> Go Back
          </button>

          <h1 className="w-full lg:text-title-sm text-title-xsm text-center font-semibold text-white bg-primary dark:text-white py-3">
            {`Template Title: ${selectedTemplate?.appraisalTemplate?.templateTitle}`}
          </h1>
          <div className="w-34" />
        </div>
        <div className="p-4">
          <div>
            {selectedTemplate?.appraisalTemplate?.appraisalQuestions?.map(
              (question, qIndex) => (
                <div key={question.id} className="mb-5">
                  <div className="font-semibold text-base ml-2">
                    {`${qIndex + 1}. ${question.questionTitle}`}
                  </div>
                  <div className="ml-8">{question.questionSubTitle}</div>
                  <div className="mt-4 ml-12">
                    {question.questionOptions?.map((optionObj, optionIndex) => {
                      const optionValue = optionObj?.["optionTitle"];

                      return (
                        <p key={optionObj.id}>
                          <span className="font-medium mr-2">
                            {String.fromCharCode(65 + optionIndex)}.
                          </span>
                          {question.optionType === 1 ? (
                            <input
                              type="checkbox"
                              className="mr-2"
                              checked={
                                selectedTemplate?.appraisalQuestionAnswer?.find(
                                  (opt) =>
                                    opt?.selectedOptionId === optionObj?.id
                                ) || false
                              }
                              onChange={(e) =>
                                handleCheckBoxChange(
                                  e,
                                  question?.id,
                                  optionObj?.id
                                )
                              }
                            />
                          ) : (
                            <input
                              type="radio"
                              className="mr-2"
                              name={`question-${question.id}`}
                              checked={
                                selectedTemplate?.appraisalQuestionAnswer?.some(
                                  (opt) =>
                                    opt?.selectedOptionId === optionObj?.id
                                ) || false
                              }
                              onChange={(e) =>
                                handleRadioChange(
                                  e,
                                  question?.id,
                                  optionObj?.id
                                )
                              }
                            />
                          )}
                          {optionValue}
                        </p>
                      );
                    })}
                    <div className="mt-5">
                      <p>Comments</p>
                      <textarea
                        className="block p-2.5 w-full h-12 text-sm text-gray-900 bg-gray-50 rounded-lg border-[1px] border-stroke focus:ring-primary focus:border-red-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Write your comments.."
                        value={
                          selectedTemplate?.appraisalQuestionAnswer?.find(
                            (obj) =>
                              obj?.appraisalQuestions?.id === question?.id
                          )?.comment || ""
                        }
                        onChange={(e) =>
                          handleInputComment(
                            e,
                            question.optionType,
                            question?.id
                          )
                        }
                      ></textarea>
                    </div>
                  </div>
                </div>
              )
            )}
            <div className="mt-10 border-t-2 border-stroke shadow-default">
              <p className="mt-5">Additional Comments</p>
              <textarea
                className="block p-2.5 w-full h-12 text-sm text-gray-900 bg-gray-50 rounded-lg border-[1px] border-stroke focus:ring-primary focus:border-red-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Write your comments.."
                onChange={(e) => {
                  setSelectedTemplate((prevValues) => ({
                    ...prevValues,
                    additionalComments: e.target.value,
                  }));
                }}
                value={selectedTemplate?.additionalComments || ""}
              ></textarea>
            </div>
          </div>
          <div className="flex justify-end gap-10 mt-5">
            <div className="border-solid border-2 p-2 font-xl rounded-md text-white px-5 bg-[#1F7FBB] mr-10">
              <button onClick={handleEditAppraisal}>Save</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateManagerAppraisal;
